import { Eyebrow } from '../concept/eyebrow';

/**
 * Scrub through the scans, Start on the left and Now on the right.
 *
 * The concept asks for a Start position so the timeline reads left-to-right
 * like Then → Now → Goal does. The scrubber already spanned 0…n; what was
 * missing was saying so, and a tick per scan so the stops are visible rather
 * than discovered by dragging.
 */
export const ScanScrubber: React.FC<{
  dates: Date[];
  index: number;
  onChange: (index: number) => void;
}> = ({ dates, index, onChange }) => {
  const last = dates.length - 1;
  const at = (i: number) => (last === 0 ? 0 : (i / last) * 100);

  return (
    <div
      data-testid="scan-scrubber"
      className="flex flex-col gap-2 rounded-lg border border-border bg-card p-5"
    >
      <div className="flex items-baseline justify-between gap-4">
        <Eyebrow>Scan timeline</Eyebrow>
        <span className="tabular text-xs font-semibold">
          {dates[index]?.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          })}
        </span>
      </div>

      <div className="relative h-8">
        <div className="absolute inset-x-0 top-3 h-[3px] rounded-sm bg-divider" />
        <div
          className="absolute left-0 top-3 h-[3px] rounded-sm bg-primary"
          style={{ width: `${at(index)}%` }}
        />
        {dates.map((_, i) => (
          <div
            key={i}
            className={`absolute top-[9px] h-[7px] w-[7px] -ml-[3px] rounded-full ${
              i <= index ? 'bg-primary' : 'bg-lean-pale'
            }`}
            style={{ left: `${at(i)}%` }}
          />
        ))}
        <div
          className="absolute top-1.5 h-[15px] w-[15px] -ml-[7px] rounded-full border-[3px] border-primary bg-card"
          style={{ left: `${at(index)}%` }}
        />

        <input
          type="range"
          min={0}
          max={last}
          step={1}
          value={index}
          aria-label="Scan"
          onChange={(e) => onChange(Number(e.target.value))}
          className="absolute inset-x-0 top-0 h-6 w-full cursor-pointer appearance-none bg-transparent
                     [&::-webkit-slider-thumb]:h-6 [&::-webkit-slider-thumb]:w-6
                     [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full
                     [&::-webkit-slider-thumb]:bg-transparent
                     [&::-moz-range-thumb]:h-6 [&::-moz-range-thumb]:w-6
                     [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-transparent"
        />
      </div>

      <div className="flex justify-between font-mono text-[8.5px] font-medium uppercase tracking-[0.08em]">
        <span className="text-muted-foreground">Start</span>
        <span className="text-primary">Now</span>
      </div>
    </div>
  );
};
